import { CommonModule } from '@angular/common';
import { Component, NgModule, OnInit, ViewChild } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { DxFormModule } from 'devextreme-angular/ui/form';
import { DxLoadIndicatorModule } from 'devextreme-angular/ui/load-indicator';
import { ReactiveFormsModule } from '@angular/forms';
import { FormControl, FormGroup, FormBuilder, Validators, Form } from '@angular/forms';

import {
  DxSelectBoxModule,
  DxCheckBoxModule,
  DxTextBoxModule,
  DxDateBoxModule,
  DxButtonModule,
  DxValidatorModule,
  DxValidatorComponent,
  DxValidationSummaryModule,
} from 'devextreme-angular';

import notify from 'devextreme/ui/notify';
import { AuthService } from '../../services/auth/auth.service';
import { UserService } from '../../services/users/users.service';

import { UserCreation, UserRegistration } from '../../models/user-credentials';
//import { Roles } from '../../services/users/roles-model';
import ArrayStore from 'devextreme/data/array_store';
import { Pais } from '../../models/pais.model';
import { Provincia } from '../../models/provincia.model';
import { Localidad } from '../../models/localidad.model';
import { ValueChangedEvent } from 'devextreme/ui/drop_down_box';
import { CondicionFiscal, Personeria, Rol, TipoDocumento } from '../../models/pjf.model';
import { ZonaDeEntrega } from '../../models/zona-entrega.model';

const sendRequest = function (value:any) {
  const invalidEmail = 'test@dx-email.com';
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(value !== invalidEmail);
    }, 1000);
  });
};

@Component({
  selector: 'app-create-account-form',
  templateUrl: './create-account-form.component.html',
  styleUrls: ['./create-account-form.component.scss']
})
export class CreateAccountFormComponent implements OnInit {

  @ViewChild('targetValidator', { static: false }) validator: DxValidatorComponent | undefined;

  registrationForm: FormGroup = {} as FormGroup;

  password = '';
  confirmPassword = '';
  passwordMode = 'password';
  confirmPasswordMode = 'password';
  maxDate: Date = new Date();
  // cityPattern = '^[^0-9]+$';
  namePattern: any = /^[^0-9]+$/;
  // phonePattern: any = /^[02-9]\d{10}$/;

  // // Direccion
  // paises: Pais[]=[];
  // provincias: Provincia[]=[];
  // provinciasxPais: Provincia[]=[];
  // localidades: Localidad[]=[];
  // localidadesxProvincia: Localidad[]=[];

  // personeria: Personeria[] = [];
  // roles: Rol[] = [];
  // condicionFiscal: CondicionFiscal[] = [];
  // tipoDocumento: TipoDocumento[] = [];

  // // Direccion de entrega
  // provinciasxPaisEntrega: Provincia[]=[];
  // localidadesxProvinciaEntrega: Localidad[]=[];

  // zonasDeEntrega: ZonaDeEntrega[]=[];

  // checkboxEntrega_value: boolean | undefined | null = false;

  // phoneRules: any = {
  //   X: /[02-9]/,
  // };




  loading = false;
  formData: any = {};
  data: any;
  //roles: Roles[];
  rol: number = 0;


  ngOnInit(): void {

    // Carga de lookups
    //this.cargarLookups();

    // Creacion del formulario de registro
        this.registrationForm = this.formBuilder.group({
          email: ['', [Validators.required, Validators.email]],
          password: ['', Validators.required],
          confirmPassword: ['', Validators.required],
          //razonSocial: [''],
          // tipoDoc: [''],
          // nroDoc: [''],
          nombre: [''],
          apellido: [''],
          // pais: [''],
          // provincia: [''],
          // localidad: [''],
          // domicilio: [''],
          // cp: [''],
          // paisEntrega: [''],
          // provinciaEntrega: [''],
          // localidadEntrega: [''],
          // domicilioEntrega: [''],
          // cpEntrega: [''],
          // telefono: [''],
          // personeria: [''],
          // rol: [''],
          // condicionFiscal: [''],
          // zonaDeEntrega: ['']


        });
  }

  constructor(
      private authService: AuthService,
      private router: Router,
      //private userSvc: UserService,
      private formBuilder: FormBuilder
    ) {

      //this.cargarLookups();



  }

  // private cargarLookups()
  // {
  //     // Carga de lookups
  //     this.obtenerPaises();
  //     this.obtenerProvincias();
  //     this.obtenerLocalidades();
  //     this.obtenerRoles();
  //     this.obtenerPersoneria();
  //     this.obtenerCondicionFiscal();
  //     this.obtenerTipoDocumento();
  //     this.obtenerZonasDeEntrega();

  // }

  // private obtenerTipoDocumento() {
  //   this.userSvc.getTipoDocumento().subscribe(data => {
  //     this.tipoDocumento = data;
  //   });
  // }

  // private obtenerCondicionFiscal() {
  //   this.userSvc.getCondicionFiscal().subscribe(data => {
  //     this.condicionFiscal = data;
  //   });
  // }

  // private obtenerPersoneria() {
  //   this.userSvc.getPersoneria().subscribe(data => {
  //     this.personeria = data;
  //   });
  // }

  // private obtenerPaises() {
  //   this.userSvc.getPaises().subscribe(data => {
  //     this.paises = data;
  //   });
  // }

  // private obtenerRoles() {
  //   this.userSvc.getRoles().subscribe(data => {
  //     this.roles = data;
  //   });
  // }

  // private obtenerProvincias() {
  //   this.userSvc.getProvincias().subscribe(data => {
  //     this.provincias = data;
  //   });
  // }

  // private obtenerLocalidades() {
  //   this.userSvc.getLocalidades().subscribe(data => {
  //     this.localidades = data;
  //   });
  // }

  // private obtenerZonasDeEntrega() {
  //   this.userSvc.getZonasDeEntrega().subscribe(data => {

  //     this.zonasDeEntrega = data.data;
  //   });
  // }




  passwordButton: any = {
    icon: 'assets/images/icons/eye.png',
    type: 'default',
    onClick: () => {
      this.passwordMode = this.passwordMode === 'text' ? 'password' : 'text';
    },
  };

  confirmPasswordButton: any = {
    icon: 'assets/images/icons/eye.png',
    type: 'default',
    onClick: () => {
      this.confirmPasswordMode = this.confirmPasswordMode === 'text' ? 'password' : 'text';
    },
  };

  // obtenerProvinciaxPais(e: ValueChangedEvent) {
  //   this.provinciasxPais = this.provincias.filter(provincia => provincia.IdPais === e.value);
  //   return this.provinciasxPais;

  // }


  // obtenerLocalidadxProvincia(e: ValueChangedEvent) {
  //   this.localidadesxProvincia = this.localidades.filter(localidad => localidad.IdProvincia === e.value);
  //   return this.localidadesxProvincia;

  // }
  // obtenerProvinciaxPaisEntrega(e: ValueChangedEvent) {
  //   this.provinciasxPaisEntrega = this.provincias.filter(provincia => provincia.IdPais === e.value);
  //   return this.provinciasxPaisEntrega;

  // }


  // obtenerLocalidadxProvinciaEntrega(e: ValueChangedEvent) {
  //   this.localidadesxProvinciaEntrega = this.localidades.filter(localidad => localidad.IdProvincia === e.value);
  //   return this.localidadesxProvinciaEntrega;

  // }


  onSubmit(e: Event) {
    e.preventDefault();
    const  userData : UserRegistration = this.registrationForm.value;

    // La direccion de entrega es la misma que la de facturacion
    // if (this.checkboxEntrega_value === false) {
    //   userData.paisEntrega = userData.pais;
    //   userData.provinciaEntrega = userData.provincia;
    //   userData.localidadEntrega = userData.localidad;
    //   userData.domicilioEntrega = userData.domicilio;
    //   userData.domicilioEntrega = userData.domicilio;
    //   userData.cpEntrega = userData.cp;

    // }

    this.loading = true;

    const result = this.authService.crearCuenta(userData).subscribe(
      (data) => {
        this.loading = false;
        notify(data.message, 'Exito', 5000);
        //notify("Cuenta creada correctamente, verifique su email para validar la misma y poder operar en el sistema", 'Exito', 2000);
        this.router.navigate(['/login-form']);
      },
      (data:any) => {
        notify("Se produjo un error al crear la cuenta: " + data.error, 'Error', 2000);
        console.log(data.error);

        this.loading = false;
      });


  }

  // habilitaODesahabilitaDirEntrega(e: Event) {
  //   this.checkboxEntrega_value = !this.checkboxEntrega_value;

  // }

  onSelectValueChanged(e: any) {
    this.formData.rol = e.value;
  }


  passwordComparison = () => this.password;

  checkComparison() {
    return true;
  }

  asyncValidation(params: any) {
    return sendRequest(params.value);
  }

  onPasswordChanged() {
    if (this.confirmPassword) {
      this.validator?.instance.validate();
    }
  }

}
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DxFormModule,
    DxLoadIndicatorModule,
    DxSelectBoxModule,
    DxCheckBoxModule,
    DxTextBoxModule,
    DxDateBoxModule,
    DxButtonModule,
    DxValidatorModule,
    DxValidationSummaryModule,
    ReactiveFormsModule



  ],
  declarations: [ CreateAccountFormComponent ],
  exports: [ CreateAccountFormComponent ]
})
export class CreateAccountFormModule { }
